<template>
    <div class="channelItem planItem" :class="{'planItemDark':isDark}">
        <div class="title">
            <div class="left">
                <p>
                    <img src="@/assets/img/datamodel/match/iconSmallPlan.png" alt="图表">
                    {{data.info.name}}
                </p>
                <em v-if="data.is_buy == 1 && data.has_data == 1" @click="goto(data.analy.url2)">查看详情分析 ></em>
                <span v-else>{{  data.info.tag }}</span>
            </div>
            <div class="right">{{data.info.buy_count}}人解锁</div>
        </div>
        <div class="con">
            <div v-if="data.is_buy == 0 && data.has_data == 1" class="noVipHaveData" @click="goto(data.analy.url1)">
                <img v-if="isDark" src="@/assets/img/datamodel/match/noDataPlanDark.png" alt=""/>
                <img v-else src="@/assets/img/datamodel/match/noDataPlan.png" alt=""/>
            </div>
            <div v-if="data.has_data == 0" class="noData">
                <div class="txt">
                    {{ data.info.desc }}
                </div>
                <div class="btm">
                    <div class="top">
                       <p class="res"> <span>历史命中</span> {{ dealDate(data.schedule.match_time) }} {{ data.schedule.sclass_name }}</p>
                       <p class="btn" @click="goto(data.info.url)">查看更多比赛预测</p>
                    </div>
                    <div class="info">
                        <div class="bettel">
                            <div class="team">
                                <p>{{ data.schedule.home_team }}</p>
                                <span>{{ data.schedule.home_score }}</span>
                            </div>
                            <div class="team">
                                <p>{{ data.schedule.guest_team }}</p>
                                <span>{{ data.schedule.guest_score }}</span>
                            </div>
                        </div>
                        <div class="predict">
                            <img src="../../../assets/img/datamodel/match/hit.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="data.is_buy == 1 && data.has_data == 1" class="haveData">
                <div class="predictInfo">
                    <p class="header">第{{data.analy.period_no}}期 第<span>{{ data.analy.num }}</span>场</p>
                    <div class="predictBox">
                        <div class="tips">{{ dealPlayType(data.analy.play_type) }}</div>
                        <div class="predict" :class="{'predictLq':!(data.analy.sport_id==2 && data.analy.play_type==2)}">
                            <div class="item" :class="{'pre': data.analy.predict_result == 1}">
                                <p>{{data.analy.play_type == 3?(data.analy.sport_id==1?'大球':'大分'):'主胜'}}</p>
                                <span>{{ data.analy.current_left }}</span>
                            </div>
                            <div v-if="!(data.analy.sport_id==2 && data.analy.play_type==2)" class="item mid" :class="{'pre': data.analy.predict_result == 3}">
                                <p>{{ data.analy.play_type == 3?'总进球':data.analy.play_type == 1?'让球':'平局' }}</p>
                                <span>{{data.analy.play_type == 3 || data.analy.play_type == 1 ? data.analy.ovalue : data.analy.current_middle}}</span>
                            </div>
                            <div class="item" :class="{'pre': data.analy.predict_result == 2}">
                                <p>{{data.analy.play_type == 3?(data.analy.sport_id==1?'小球':'小分'):'客胜'}}</p>
                                <span>{{ data.analy.current_right }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="progressBox">
                    <p class="header">指标计算</p>
                    <div class="thead">
                        <div class="res left">{{data.analy.play_type == 3?(data.analy.sport_id==1?'大球':'大分'):'主队'}}</div>
                        <div class="name">指标维度</div>
                        <div class="res right">{{data.analy.play_type == 3?(data.analy.sport_id==1?'小球':'小分'):'客队'}}</div>
                    </div>
                    <div class="tbody">
                        <template v-if="data.analy.play_type != 3">
                            <div class="pitem">
                                <div class="res progress left">
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.homeStrength + '%'}"></div>
                                    </div>
                                    <span>{{ data.analy.target.homeStrength }}</span>
                                </div>
                                <div class="name">实力对比</div>
                                <div class="res progress right">
                                    <span>{{ data.analy.target.awayStrength }}</span>
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.awayStrength + '%'}"></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="pitem">
                                <div class="res progress left">
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.homeDefense + '%'}"></div>
                                    </div>
                                    <span>{{ data.analy.target.homeDefense }}</span>
                                </div>
                                <div class="name">主队攻防</div>
                                <div class="res progress right">
                                    <span>{{ data.analy.target.awayDefense }}</span>
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.awayDefense + '%'}"></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-if="data.analy.play_type != 3">
                            <div class="pitem">
                                <div class="res progress left">
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.homeState + '%'}"></div>
                                    </div>
                                    <span>{{ data.analy.target.homeState }}</span>
                                </div>
                                <div class="name">近期状态</div>
                                <div class="res progress right">
                                    <span>{{ data.analy.target.awayState }}</span>
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.awayState + '%'}"></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="pitem">
                                <div class="res progress left">
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.homeUnDefense + '%'}"></div>
                                    </div>
                                    <span>{{ data.analy.target.homeUnDefense }}</span>
                                </div>
                                <div class="name">客队攻防</div>
                                <div class="res progress right">
                                    <span>{{ data.analy.target.awayUnDefense }}</span>
                                    <div class="process">
                                        <div class="pre" :style="{'width': data.analy.target.awayUnDefense + '%'}"></div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="pitem">
                            <div class="res progress left">
                                <div class="process">
                                    <div class="pre" :style="{'width': data.analy.target.homePrefer + '%'}"></div>
                                </div>
                                <span>{{ data.analy.target.homePrefer }}</span>
                            </div>
                            <div class="name">{{data.analy.play_type == 3?'大小':(data.analy.sport_id == 1?'让球':'让分')}}倾向</div>
                            <div class="res progress right">
                                <span>{{ data.analy.target.awayPrefer }}</span>
                                <div class="process">
                                    <div class="pre" :style="{'width': data.analy.target.awayPrefer + '%'}"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'planItem',
    props: ['data', 'isDark'],
    methods: {
        goto (url) {
            this.$emit('goModel', url)
        },
        dealDate (str) {
            return str.substring(5, 10).replace('-', '/')
        },
        dealPlayType (index) {
            const str = index + ''
            if (str === '1') {
                return '让球'
            } else if (str === '2') {
                return '竞足'
            } else if (str === '3') {
                return '总进球'
            } else if (str === '16') {
                return '让球胜平负'
            }
        }
    }
}
</script>

<style lang="less" scoped>
.planItem{
    .noData{
        .predict{
            width: 50px;
            height: 50px;
            img{
                width: 100%;
            }
        }
    }
    .haveData{
        padding: 10px;
        background-color: #fff;
        .predictInfo{
            p.header{
                font-size: 10px;
                line-height: 14px;
                color: #999999;
                span{
                    color: #169AFF;
                }
            }
            .predictBox{
                display: flex;
                justify-content: space-between;
                width: 100%;
                height: 40px;
                border-radius: 5px;
                overflow: hidden;
                margin-top: 4px;
                .tips{
                    width: 25px;
                    font-size: 12px;
                    color: #169AFF;
                    line-height: 17px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: rgba(22, 154, 255, .1);
                    padding: 0 5px;
                }
                .predict{
                    width: calc(100% - 25px);
                    height: 100%;
                    background-color: #F5F5F5;
                    display: flex;
                    justify-content: space-between;
                    .item{
                        width: 33.33%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                        color: #333333;
                        position: relative;
                        p{
                            font-size: 15px;
                            font-weight: bold;
                        }
                        span{
                            font-size: 12px;
                        }
                        i{
                            display: block;
                            width: 15px;
                            height: 15px;
                            background: #FFFFFF;
                            border-radius: 0px 0px 5px 0px;
                            position: absolute;
                            top: 0;
                            left: 0;
                            color: #FF5048;
                        }
                    }
                    .mid{
                        &:before{
                            content: "";
                            width: 1px;
                            height: 20px;
                            background-color: #cccccc;
                            display: block;
                            position: absolute;
                            left: 0;
                            top: 10px;
                        }
                        &:after{
                            content: "";
                            width: 1px;
                            height: 20px;
                            background-color: #cccccc;
                            display: block;
                            position: absolute;
                            right: 0;
                            top: 10px;
                        }
                    }
                    .pre{
                        background-color: #169AFF;
                        color: #ffffff;
                    }
                }
                .predictLq{
                    .item{
                        width: 50%;
                    }
                }
            }
        }
        .progressBox{
            margin-top: 12px;
            p.header{
                font-size: 13px;
                color: #333333;
                font-weight: bold;
                line-height: 19px;
            }
            .thead{
                display: flex;
                justify-content: space-between;
                height: 24px;
                line-height: 24px;
                background-color: #F5F5F5;
                .left{
                    text-align: right;
                    padding-right: 12px;
                }
                .right{
                    text-align: left;
                    padding-left: 12px;
                }
            }
            .pitem{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 30px;
                .progress{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span{
                        display: block;
                        width: 37px;
                        font-size: 12px;
                        color: #333333;
                        line-height: 17px;
                        text-align: center;
                    }
                    .process{
                        width: calc(100% - 37px);
                        height: 5px;
                        background-color: #eeeeee;
                        border-radius: 3px;
                        overflow: hidden;
                        position: relative;
                        .pre{
                            width: 50%;
                            position: absolute;
                            top: 0;
                            height: 100%;
                            width: 50%;
                            border-radius: 3px;
                        }
                    }
                }
                .left .pre{
                    right: 0;
                    background-color: #FF5048;
                }
                .right .pre{
                    left: 0;
                    background-color: #169AFF;
                }
            }
            .name{
                width: 64px;
                border-left: 1px solid #ffffff;
                border-right: 1px solid #ffffff;
                text-align: center;
            }
            .left,.right{
                width: calc(50% - 32px);
            }
        }
    }
}
.planItemDark{
    .haveData{
        background-color: #232323 !important;;
        .predictInfo{
            p.header{
                color: #595959 !important;;
            }
            .predictBox{
                .predict{
                    background-color: #191919 !important;;
                    .item{
                        color: #d3d3d3 !important;;
                        i{
                            background-color: #191919 !important;;
                        }
                    }
                    .mid{
                        &:before{
                            content: "";
                            width: 1px;
                            height: 20px;
                            background-color: #595959 !important;
                            display: block;
                            position: absolute;
                            left: 0;
                            top: 10px;
                        }
                        &:after{
                            content: "";
                            width: 1px;
                            height: 20px;
                            background-color: #595959 !important;
                            display: block;
                            position: absolute;
                            right: 0;
                            top: 10px;
                        }
                    }
                }
            }
        }
        .progressBox{
            p.header{
                color: #d3d3d3 !important;
            }
            .thead{
                background-color: #191919 !important;
            }
            .pitem{
                .progress{
                    span{
                        color: #d3d3d3 !important;
                    }
                    .process{
                        background-color: #2f2f2f !important;
                    }
                }
            }
            .name{
                border-color: #191919 !important;
            }
        }
    }
}
</style>
